import './FileUploadButton.css'
import cx from 'classnames'
import { buttonClasses, ButtonSize, ButtonVariant } from '../Button/Button'
import React from 'react'
import { UploadArrowUpIcon } from '../icons'
import { Spinner } from '../Spinner/Spinner'

export function FileUploadButton({
  children,
  className,
  onChange,
  sizeType = 'sm',
  variant = 'default',
  disabled,
  isLoading
}: {
  children: React.ReactNode
  className?: string
  variant?: ButtonVariant
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
  sizeType?: ButtonSize
  disabled?: boolean
  isLoading?: boolean
}) {
  const [value, setValue] = React.useState('')
  const onChangeHandler = (evt: React.ChangeEvent<HTMLInputElement>) => {
    onChange(evt)
    setValue('')
  }
  return (
    <label
      className={cx(
        buttonClasses.buttonBaseClassName,
        'file-upload-button',
        disabled ? 'file-upload-button-disabled' : 'file-upload-button-enabled',
        buttonClasses.variantToClasses[variant],
        buttonClasses.sizeTypeToClasses[sizeType],
        className
      )}
    >
      <input
        onChange={onChangeHandler}
        disabled={disabled}
        type="file"
        className="file-upload-input"
        value={value}
      />

      {isLoading ? (
        <Spinner
          className={cx('file-upload-icon', {
            'file-upload-spinner-default': variant === 'default'
          })}
        />
      ) : (
        <UploadArrowUpIcon className="file-upload-icon" />
      )}
      {children}
    </label>
  )
}
